import { stripDomain } from '@hotjar/webapp/utils/urls';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import type { TrackingArgs } from './types';
import { validateEventData } from './validate-event-data';
import * as hotjarTracking from './tools/hotjar';

/**
 * Track when something was viewed.
 */
export const viewElement = ({
  name,
  uiPosition,
  groupData,
  data = {},
}: TrackingArgs): Promise<void> => {
  const valid = validateEventData('Track.viewElement', [name, uiPosition, groupData]);

  if (valid) {
    const url = stripDomain(window.location.href);
    const trackData = {
      element_name: name,
      ui_position: uiPosition,
      url_event_was_triggered_on: url, // we add the url_event_was_triggered_on as current page url in case it is not defined in the groupData
      ...data,
      ...groupData,
    };

    hotjarTracking.tagRecording(`Viewed: ${name} - ${uiPosition}`);
    return Segment.track('Element Viewed', trackData);
  }

  return Promise.resolve();
};
